{	"main": {
		"title": "Dokumentacija nalogov",
		"nazaj": "Nazaj"
	},
	"stevilcni": {
		"vsiD": "Vsi dokumenti",
		"vsiN1": "Vsi",
		"vsiN2": "NE",
		"vsiN3": "-potrjeni dokumenti",
		"vsiP": "Vsi potrjeni nalogi",
		"vsiZ": "Vsi zavrnjeni nalogi"
	},
	"potrjevanje": {
		"odobri": "Odobri",
		"zavrni": "Zavrni",
		"naloge": "naloge",
		"datum": "Datum",
		"poslal": "Poslal",
		"odobreni": "odobreni",
		"nalogi": "nalogi",
		"zavrnjeni": "zavrnjeni"
	},
	"table": {
		"nalogiTitle": "Nalogi"
	},
	"modal": {
		"opomba": "Opomba: Zakaj zavračam dokument (pri zavračanju je vnos obvezen) / opomba k potrjenemu dokumentu (za potrjen dokument je lahko polje prazno)"
	},
	"buttons": {
		"stevilcni": "Številčni pregled",
		"zapriPregled": "Zapri pregled",
		"zavrniDokument": "Zavrni dokument",
		"potrdiDokument": "Potrdi dokument"
	}
}